import App from '@/App.vue';
import NotFound from '@/components/NotFound.vue';
import TheLogin from '@/components/TheLogin.vue';
import TopNavBar from '@/components/TopNavBar.vue';
import DeactiveAccount from '@/components/DeactiveAccount.vue';
import TheCart from '@/components/TheCart.vue';
import TheProducts from '@/components/TheProducts.vue';
import ProductDetails from '@/components/ProductDetails.vue';
import OrderHistory from '@/components/OrderHistory.vue';

import MenuItems from '@/components/Menu/MenuItems.vue';
import MenuDetails from '@/components/Menu/MenuDetails.vue';

import Alerts from '@/components/utilities/Alerts.vue';

export default {
  App,
  NotFound,
  TheLogin,
  TopNavBar,
  DeactiveAccount,
  TheCart,
  TheProducts,
  ProductDetails,
  OrderHistory,

  MenuItems,
  MenuDetails,

  Alerts
};
